<template>
  <el-container class="page-layout" :class="{ 'is-white': isWhiteTheme }" direction="vertical" v-watermark:[displayMark]>
    <tq-page-header @toggle-fullscreen="onToggleFullscreen" :themeType="themeType" @log-out="hasLogOut">
      <template #logo>
        <slot name="logo">
          <!-- 默认的logo图 -->
          <img src="../../../assets/images/logo.png" alt="正大天晴" />
        </slot>
      </template>
    </tq-page-header>
    <tq-page-tabs v-show="!onlyContent" class="page-layout__tabs" :tabList="tabList" :themeType="themeType"
      @getCurrentTabs="getCurrentTabs" />
    <div class="page-layout__wrap new_tabs" :class="{'is-only-content': onlyContent}">
      <tq-page-aside-menu v-show="!onlyContent" :initCollapse="isFullScreen" :menuCountObj="menuCountObj" :routes="routes"
        class="page-layout__aside" />
      <el-main class="page-layout__main">
        <div class="page-layout__content" :class="{ 'with-padding': withPadding }">
          <template v-if="tabWithCache">
            <router-view v-slot="{ Component }">
              <keep-alive :include="currentTabs">
                <component :is="Component" :key="route.fullPath" />
              </keep-alive>
            </router-view>
          </template>
          <template v-else>
            <router-view></router-view>
          </template>
        </div>
      </el-main>
    </div>
  </el-container>
</template>


<script lang="ts" setup>
import { ref, computed, nextTick } from 'vue'
import type { tabInfo } from './interface'
import type { RouteRecordRaw } from 'vue-router'
import { useRoute } from 'vue-router'
const route = useRoute()
// 全屏相关
const isFullScreen = ref(false)
const onToggleFullscreen = (toggleValue: boolean) => {
  isFullScreen.value = toggleValue
}

interface Props {
  themeType?: 'default' | 'white' | 'red';
  noLink?: boolean;
  tabWithCache?: boolean;
  menuCountObj?: object;
  displayMark?: boolean;
  onlyContent?: boolean;
  withPadding?: boolean;
  routes: any[];
}
const props = withDefaults(defineProps<Props>(), {
  themeType: "default",
  noLink: false,
  tabWithCache: false,
  menuCountObj: () => ({}),
  displayMark: true,
  onlyContent: false,
  withPadding: false,
  routes: () => [],
});

const emit = defineEmits(['log-out'])

const isWhiteTheme = computed(() => props.themeType === 'white')
// const isDefaultTheme = computed(() => props.themeType === 'default')
// const isRedTheme = computed(() => props.themeType === 'red')

// tabs相关
const currentTabs = ref<string[]>([])
const tabList = ref<RouteRecordRaw[]>([])
const getCurrentTabs = (allTabsInfo: tabInfo) => {
  const element = {
    ...allTabsInfo.item
  }
  console.log('element', element);
  
  if (allTabsInfo.type === 'add') {
    tabList.value.push({ ...element })
    if (element?.meta?.keepAlive && element.name) {
      if (!currentTabs.value.includes(element.name)) {
        nextTick(() => {
          element.name && currentTabs.value.push(element.name)
        })
      }
    }
  }

  if (allTabsInfo.type === 'remove') {
    if (element.meta?.keepAlive && element.name && currentTabs.value.includes(element.name)) {
      const tabIndex = currentTabs.value.findIndex(item => item === element.name)
      currentTabs.value.splice(tabIndex, 1)
    }
  }

}

const hasLogOut = () => {
  emit('log-out')
}

defineOptions({
  name: "TqPageLayout",
});
</script>
